"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockWaterbodyTechnique = void 0;
function mockWaterbodyTechnique(overrides = {}) {
    return {
        id: 7,
        season_group: 'mock_season_group',
        species: 'mock_species',
        technique: 'mocking_deep',
        votes_down: 0,
        votes_total: 2,
        votes_up: 2,
        waterbody: 'mock-lake',
        your_vote: 'up',
        ...overrides,
    };
}
exports.mockWaterbodyTechnique = mockWaterbodyTechnique;
